"use client";

import { c as _c } from "react/compiler-runtime";
import { sanitizeLessonHtml, type CampaignPageSection } from "@growwithai/shared";
import { RICH_HTML_CLASS } from "../types";
import { sectionBgStyle, sectionHeadingStyle } from "../section-style";
type AboutProps = Extract<CampaignPageSection, {
  type: "about";
}>;

/** Tentang bimbel — body_html disanitasi ulang di klien (defense-in-depth). */
export default function AboutSection(t0) {
  const $ = _c(15);
  const {
    section
  } = t0;
  let t1;
  if ($[0] !== section.custom_style) {
    t1 = sectionBgStyle(section.custom_style);
    $[0] = section.custom_style;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== section.custom_style || $[3] !== section.heading) {
    t2 = section.heading && <h2 className="mb-6 text-2xl font-bold tracking-tight text-warm-black md:text-3xl" style={sectionHeadingStyle(section.custom_style)}>{section.heading}</h2>;
    $[2] = section.custom_style;
    $[3] = section.heading;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== section.body_html) {
    t3 = sanitizeLessonHtml(section.body_html);
    $[5] = section.body_html;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <div className={RICH_HTML_CLASS} dangerouslySetInnerHTML={{
      __html: t3
    }} />;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="mx-auto max-w-3xl px-5">{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t5) {
    t6 = <section className="bg-white py-14 md:py-20" style={t1}>{t5}</section>;
    $[12] = t1;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}